module.exports = __webpack_public_path__ + "static/media/fiji-airways-480p.575c8ee6.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/video/fiji-airways-480p.mov
// module id = 505
// module chunks = 0